import ResolveDiscussionButton from '../../../notes/components/resolve_discussion_button.vue?vue3';
import DiscussionReplyPlaceholder from '../../../notes/components/discussion_reply_placeholder.vue?vue3';
import { __ } from '~/locale';
import discussionToggleResolveMutation from '../graphql/discussion_toggle_resolve.mutation.graphql';
export default {
    name: 'DiscussionActions',
    components: {
        DiscussionReplyPlaceholder,
        ResolveDiscussionButton
    },
    props: {
        discussionId: {
            type: String,
            required: true
        },
        showResolveButton: {
            type: Boolean,
            required: false,
            default: false
        },
        isResolved: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'show-reply-form'
    ],
    data () {
        return {
            loading: false
        };
    },
    computed: {
        toggleResolveBtnLabel () {
            return this.isResolved ? __('Reopen thread') : __('Resolve thread');
        }
    },
    methods: {
        async onToggleResolve () {
            this.loading = true;
            try {
                await this.$apollo.mutate({
                    mutation: discussionToggleResolveMutation,
                    variables: {
                        id: this.discussionId,
                        resolve: !this.isResolved
                    }
                });
            } finally{
                this.loading = false;
            }
        }
    }
};
